<template>
  <div class="bg bg-skills mb-5">
    <div class="skills container">
      <div class="mb-5">
        <h1 id="skills" class="skills__title">
          <span class="marker">{{ skillsTitle }}</span>
        </h1>
        <code>{{ skillsSlogan }}</code>
      </div>
      <div class="skills__box">
        <div class="card">
          <div class="container">
            <h3 class="card--title">
              <b>{{ skillsWebCore }}</b>
            </h3>
            <div class="row">
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/html-5--v1.png"
                  alt="html-5--v1"
                  title="HTML"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/css3.png"
                  alt="css3"
                  title="CSS"
                />
              </div>
              <div class="col py-3">
                &nbsp;<img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/fluency/48/javascript.png"
                  alt="javascript"
                  title="JavaScript"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/sass.png"
                  alt="sass"
                  title="Sass/Scss"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/pug.png"
                  alt="pug"
                  title="Pug.js"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/48/external-jquery-is-a-javascript-library-designed-to-simplify-html-logo-shadow-tal-revivo.png"
                  alt="external-jquery-is-a-javascript-library-designed-to-simplify-html-logo-shadow-tal-revivo"
                  title="jQuery"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="container">
            <h3 class="card--title">
              <b>Programming</b>
            </h3>
            <div class="row">
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/c-programming.png"
                  alt="c-programming"
                  title="C lang"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/c-plus-plus-logo.png"
                  alt="c-plus-plus-logo"
                  title="C++ lang"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/python--v1.png"
                  alt="python--v1"
                  title="Python"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/java-coffee-cup-logo--v1.png"
                  alt="java-coffee-cup-logo--v1"
                  title="Java lang"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/dusk/48/php-logo.png"
                  alt="php-logo"
                  title="PHP"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/sql.png"
                  alt="sql"
                  title="SQL for databases"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="container">
            <h3 class="card--title">
              <b>{{ skillsFrame }}</b>
            </h3>
            <div class="row">
              <div class="col py-3">
                &nbsp;<img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/bootstrap.png"
                  alt="bootstrap"
                  title="Bootstrap"
                />
              </div>
              <div class="col py-3">
                &nbsp;<img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/officel/48/react.png"
                  alt="react"
                  title="React.js"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/vue-js.png"
                  alt="vue-js"
                  title="Vue.js"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/nuxt-jc.png"
                  alt="nuxt-jc"
                  title="Nuxt.js"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/ios/48/django.png"
                  alt="django"
                  title="django"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="container">
            <h3 class="card--title"><b>Tools</b></h3>
            <div class="row">
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/git.png"
                  alt="git"
                  title="git"
                />
              </div>
              <div class="col py-3">
                &nbsp;<img
                width="48"
                height="48"
                src="https://img.icons8.com/ios-glyphs/48/github.png"
                alt="github"
                title="github"
              />
              </div>
              <div class="col py-3">
                <img
                width="48"
                height="48"
                src="https://img.icons8.com/fluent/30/ffffff/visual-studio-code-2019.png"
                alt="VScode"
                title="VScode"
                />
              </div>
              <div class="col py-3">
                <img
                width="48"
                height="48"
                src="https://img.icons8.com/color/48/jetbrains.png"
                alt="jetbrains"
                title="JetBrains Tools"
                />
              </div>
              <div class="col py-3">
                &nbsp;<img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/nodejs.png"
                  alt="nodejs"
                  title="nodejs"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/heroku.png"
                  alt="heroku"
                  title="Heroku"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/external-tal-revivo-color-tal-revivo/48/external-postman-is-the-only-complete-api-development-environment-logo-color-tal-revivo.png"
                  alt="external-postman-is-the-only-complete-api-development-environment-logo-color-tal-revivo"
                  title="Postman"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/ubuntu--v1.png"
                  alt="ubuntu--v1"
                  title="Ubuntu Linux"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/virtualbox.png"
                  alt="virtualbox"
                  title="VirtualBox"
                />
              </div>
              <div class="col py-3">
                <img
                  width="48"
                  height="48"
                  src="https://img.icons8.com/color/48/docker.png"
                  alt="docker"
                  title="Docker"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Skills",
  data() {
    return {
      skillsTitle: "Skills & Tools",
      skillsSlogan: "Solving problem & Spring up idea",
      skillsWebCore: "Web",
      skillsFrame: "Frameworks"
    };
  }
};
</script>

<style lang="scss">
@import "@/assets/css/_variables.scss";

.bg-skills {
  // background-image: linear-gradient(
  //   115deg,
  //   rgba(58, 158, 125, 0.8),
  //   rgba(136, 136, 206, 0.7)
  // );
  background-repeat: no-repeat;
  background-size: cover;
}

.skills {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px 20px;

  .skills__title {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    text-align: center;
    justify-content: center;
    grid-column: 1 / -1;
    font-weight: 900;
    font-size: 3rem;
    text-transform: uppercase;

    @media all and (min-width: 720px) {
      font-size: 3.5rem;
    }
  }

  .skills__box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 40px;

    .icon {
      // animation: float 6s ease-in-out infinite;
      border-radius: 5px;
      width: 55px;
      height: 60px;
      margin: 18px;

      @media all and (min-width: 720px) {
        width: 88px;
        height: 89px;
        margin: 15px;
      }
    }

    .card {
      box-shadow: 0 0 10px -1px rgba(213, 197, 197, 0.75);
      background-color: rgba(247, 245, 245, 0.68);
      transition: 0.3s;
      width: 80%;
      border-radius: 10px;
      border: none;
      height: 27rem;
      max-height: 100%;
      margin-bottom: 2rem;
      margin-right: auto;
      margin-left: auto;
      overflow: auto;

      @media all and (min-width: 415px) {
        width: 48.5%;
      }

      @media all and (min-width: 720px) {
        width: 30.333%;
      }

      &:hover {
        box-shadow: 0 0 10px -1px rgba(213, 197, 197, 0.75);
        transform: scale(1.1);
      }

      &--title {
        color: $third-color;
        font-size: 1.9rem;
        padding-top: 2.5rem;
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        position: relative;

        &:after {
          content: "";
          background: #e83e8c;
          position: absolute;
          bottom: 0;
          left: 25%;
          height: 1px;
          width: 50%;
        }
      }

      ul {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        li {
          display: inline-block;
          margin-bottom: 5px;
          color: $third-color;
          font-size: 1.7rem;

          &:before {
            content: "\2022";
            color: $first-color;
            font-weight: bold;
            display: inline-block;
            width: 1em;
            margin-left: -1em;
          }
        }
      }
    }

    .container {
      padding: 2px 16px;
    }
  }

  &--btn {
    background-color: $second-color;
    color: #fff;
    font-size: 1.5rem;
    padding: 10px 20px;
    margin: 0 auto;
    border: none;
    border-radius: 15px;
    box-shadow: 0 5px $main-color;

    a {
      text-decoration: none;
    }

    &:hover {
      background-color: $first-color;
      color: #fff;
      box-shadow: 0;
      transform: translateY(4px);
    }

    &:active {
      background-color: $third-color;
      box-shadow: 0 5px #666;
      transform: translateY(4px);
    }
  }
}

.dark {
  // .bg-skills {
  //   background-image: linear-gradient(
  //     115deg,
  //     rgba(58, 158, 125, 0.8),
  //     rgba(136, 136, 206, 0.7)
  //   );
  // }
  .skills {
    code {
      color: #fff;
    }

    .card {
      background-color: #2c3e5092;
      box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.4);

      &--title {
        color: ghostwhite;
      }

      ul {
        li {
          color: #fff;
        }
      }

      &:hover {
        box-shadow: 0 8px 16px 0 rgba(255, 255, 255, 0.4);
        transform: scale(1.1);
      }
    }

    &--btn {
      background-color: #2c3e50;
      box-shadow: 0 5px $first-color;

      &:hover {
        background-color: $third-color;
        color: #fff;
      }
    }
  }
}
</style>
